import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Inject,
  PLATFORM_ID,
  ChangeDetectionStrategy
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, ReplaySubject, takeUntil } from 'rxjs';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { TranslateService } from "@ngx-translate/core";


@Component({
  selector: 'app-anchor-navigation',
  templateUrl: './anchor-navigation.component.html',
  styleUrls: [
    './styles/anchor-navigation.component.scss',
    './styles/anchor-navigation-tablet.scss',
    './styles/anchor-navigation-mobile.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnchorNavigationComponent implements OnInit, AfterViewInit, OnDestroy {

  public fragment: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public topIndent: number = 100;
  private scrollContainer?: HTMLElement | null;
  readonly destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input()
  public anchors: any;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private _el: ElementRef,
    private translateService: TranslateService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
  }

  private scrollListener = () => {
    let currentSection: string = '';
    const children = this.document.getElementsByClassName('section-container');

    for (let i = 0; i < children.length; i++) {
      const element = children[i];
      if (this.topIndent > (element.getBoundingClientRect().top)) {
        currentSection = element.id;
      }

      this.fragment.next(currentSection);
    }
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId) && this.document) {
      const headerElement = this.document.getElementById('header');
      const anchorContainerElement = this.document.getElementById('anchor-container');
      // @ts-ignore
      this.topIndent = headerElement.getBoundingClientRect().height + anchorContainerElement.getBoundingClientRect().height + 100;

      window.addEventListener('scroll', this.scrollListener)

    }

    if (this.anchors && this.anchors.length) {
      this.route.fragment
        .pipe(takeUntil(this.destroy$))
        .subscribe(fragment => {
          this.fragment.next(fragment || '');
        });
    }
  }

  ngAfterViewInit(): void {
    try {
      this.scrollTo(this.fragment.value);
    } catch (e) { }
  }

  public scrollTo(fragment: string): void {
    if (isPlatformBrowser(this.platformId) && !!fragment) {
      const headerElement = document.getElementById('header');
      const id =  this.translateService.instant(fragment);
      // @ts-ignore
      const yOffset = headerElement.getBoundingClientRect().height;
      const element: HTMLElement | null = this.document.getElementById(id);
      const anchorContainerElement = this.document.getElementById('anchor-container');

      // @ts-ignore
      const y = element.getBoundingClientRect().top + window.pageYOffset - anchorContainerElement?.getBoundingClientRect().height - yOffset;
      window?.scrollTo({top: y});
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
    window.removeEventListener('scroll', this.scrollListener);
  }

}
